import React, { useEffect, useState } from "react";
import { useAppContext } from "../context/appContext";
import {
  Link,
  NavLink,
  useLocation,
  useNavigate,
  unstable_useBlocker as useBlocker,
} from "react-router-dom";
import { logo, miniLogo } from "../assets";
import { activeSideNav } from "../style/globalStyles";
import { GoFileDirectory, GoHome } from "react-icons/go";
import { RiCalendarScheduleLine, RiHomeSmile2Line } from "react-icons/ri";
import { FaAngleDown, FaRegUser } from "react-icons/fa";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import { MdOutlineSecurity } from "react-icons/md";
import { LuUser2 } from "react-icons/lu";
import { CgUserlane } from "react-icons/cg";
import { BiHome } from "react-icons/bi";
import { TbHours12 } from "react-icons/tb";
import {
  clientNav,
  inVoicing,
  managementNav,
  MapScheduleGuardManagement,
  navItems,
  reporting,
  ReportingMap,
  scheduleGuardManagement,
  userList,
} from "./sideNavComponents";
import { Header } from "./layout";
import { auth } from "../config/config";

const SideNav = ({ className }) => {
  const {
    openReport,
    setOpenReport,
    openscheduleGuardManagement,
    setOpenscheduleGuardManagement,
    openInVoicing,
    setOpenInVoicing,
    isVisibleReport,
    setIsVisibleReport,
    isVisibleSchedule,
    setIsVisibleSchedule,
    isVisibleInvoicing,
    setVisibleInvoicing,
    isUserList,
    setIsUserList,
    OpenUserList,
    setOpenUserList,
    setRemoveNav,
    UserType,
  } = useAppContext();
  // console.warn("Admin UserType", UserType);
  const showSideNav = true;
  const location = useLocation();

  useEffect(() => {
    if (openReport) {
      setIsVisibleReport(true);
    } else {
      // Delay hiding to allow transition
      const timer = setTimeout(() => setIsVisibleReport(false), 0); // Duration should match your transition time
      return () => clearTimeout(timer);
    }
  }, [openReport]);

  useEffect(() => {
    if (OpenUserList) {
      setIsUserList(true);
    } else {
      // Delay hiding to allow transition
      const timer = setTimeout(() => setIsUserList(false), 0); // Duration should match your transition time
      return () => clearTimeout(timer);
    }
  }, [OpenUserList]);

  useEffect(() => {
    if (openInVoicing) {
      setVisibleInvoicing(true);
    } else {
      // Delay hiding to allow transition
      const timer = setTimeout(() => setVisibleInvoicing(false), 0); // Duration should match your transition time
      return () => clearTimeout(timer);
    }
  }, [openInVoicing]);
  useEffect(() => {
    if (openscheduleGuardManagement) {
      setIsVisibleSchedule(true);
    } else {
      // Delay hiding to allow transition
      const timer = setTimeout(() => setIsVisibleSchedule(false), 0); // Duration should match your transition time
      return () => clearTimeout(timer);
    }
  }, [openscheduleGuardManagement]);

  const navigate = useNavigate();
  const [activeIcons, setActiveIcons] = useState("");

  const handleSignOut = async () => {
    try {
      await auth.signOut();
      console.log("Signed out successfully");
      localStorage.removeItem("maxManagement");
      window.location.href = "https://login.maximalsecurityservices.com/";
    } catch (error) {
      console.error("Sign out error:", error);
    }
  };

  // console.log("IsPathName", IsPathName);

  return (
    <div className={`${className} capitalize shadow  h-full `}>
      <div className='lg:flex  justify-start items-center pt-4 '>
        {/* <Link to='https://maximalsecurityservices.com'>
         
          <img
            src={showSideNav ? logo : miniLogo}
            alt=''
            className={`${
              showSideNav ? "max-w-40 max-h-32" : "max-w-14 min-w-14 px-2 "
            }`}
          />
         
        </Link> */}
        <Header className='h-12  pl-5' setRemoveNav={setRemoveNav} />
        <div
          className={`font-bold text-xs text-nowrap text-zinc-500 ${
            !showSideNav && "opacity-0"
          } `}
        >
          {UserType?.type === "Admin"
            ? "admin panel"
            : UserType?.type === "Client"
            ? "Client panel"
            : UserType?.type === "Management"
            ? "Management panel"
            : ""}
        </div>

        {/* <Header className='h-12 w-full' setRemoveNav={setRemoveNav} /> */}
      </div>
      <div className=' xl:text-sm   h-[calc(100%-5rem)] relative mt-2'>
        <div class='custom-scrollbar-track absolute right-0'>
          <div class='custom-scrollbar-thumb'></div>
        </div>
        <div
          className={` sidenav  h-full w-full  ${
            showSideNav ? "overflow-y-scroll" : ""
          } `}
        >
          {/* {showSideNav && ( */}

          {/* )} */}
          <div
            className={` transition-all duration-500 ease-in-out
              ${showSideNav ? "" : "flex flex-col gap-0"}
              `}
          >
             {UserType?.type === "Management" &&
              managementNav.map((item, index) => {
                return (
                   item.title === "Sign out" ? (
                    <div
                      className={`pl-5 pr-1 flex gap-2 items-center ${
                        showSideNav && ""
                      }  p-2 py-3   cursor-pointer ${
                        showSideNav
                          ? item?.path === location.pathname
                            ? activeSideNav
                            : "bg-white hover:bg-zinc-200 "
                          : "border-transparent"
                      } `}
                      onClick={handleSignOut}
                    >
                      <Icon
                        icon={item.icon}
                        imgUrl={item.imgUrl}
                        showSideNav={showSideNav}
                        activeIcons={activeIcons}
                        active={item.title}
                        onClick={() => {
                          setActiveIcons(item.title);
                          setOpenInVoicing(false);
                          setOpenscheduleGuardManagement(false);
                          setOpenReport(false);

                          setOpenUserList(false);
                          handleSignOut()
                        }}
                      />

                      <span
                        className={`text-sm text-nowrap  ${
                          !showSideNav && "opacity-0"
                        } `}
                      >
                        {item.title}
                      </span>
                    </div>
                  )
:


                  <Link to={item.path}>
                    <div
                      className={`pl-5 pr-1 flex gap-2 items-center border-b ${
                        showSideNav && ""
                      }  p-2 py-3   cursor-pointer ${
                        showSideNav
                          ? item?.path === location.pathname
                            ? activeSideNav
                            : "bg-white hover:bg-zinc-200 "
                          : "border-transparent"
                      } `}
                      // onClick={() => {
                      //   setOpenInVoicing(false);
                      //   setOpenscheduleGuardManagement(false);
                      //   setOpenReport(false);
                      //   setOpenUserList(false);
                      // }}
                    >
                      <Icon
                        icon={item.icon}
                        imgUrl={item.imgUrl}
                        showSideNav={showSideNav}
                        activeIcons={activeIcons}
                        active={item.title}
                        onClick={() => {
                          setActiveIcons(item.title);
                          // setOpenInVoicing(false);
                          // setOpenscheduleGuardManagement(false);
                          // setOpenReport(false);

                          // setOpenUserList(false);
                        }}
                      />

                      <span
                        className={`text-sm text-nowrap  ${
                          !showSideNav && "opacity-0"
                        } `}
                      >
                        {item.title}
                      </span>
                    </div>
                  </Link>
                );
              })}
            {/* <div
              className={`pl-5 pr-1 flex gap-2 items-center border-b   p-2 py-3   cursor-pointer hover:bg-red-100  hover:text-red-600`}
              onClick={handleSignOut}
            >
              <span className='text-sm text-nowrap'>Sign out</span>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideNav;

const Icon = ({ icon, imgUrl, showSideNav, activeIcons, onClick, active }) => (
  <span
    className={`text-2xl p-1.5 ${
      !showSideNav
        ? activeIcons === active && " bg-blue-200 text-blue-700    "
        : ""
    }  ${!showSideNav && "hover:bg-zinc-200 rounded-md"}  `}
    onClick={onClick}
  >
    {icon && icon}
    {imgUrl && (
      <div className='w-7 h-7 '>
        <img src={imgUrl} />
      </div>
    )}
  </span>
);
